import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { PAYMENT_METHOD_TYPE } from '@woovi/shared';
import { ActionButton, BoxFlex } from '@woovi/ui';

import type { ITPButton_charge$key } from './__generated__/ITPButton_charge.graphql.ts';
import usePaymentContext from '../context/usePaymentContext.tsx';

import type { ReactNode } from 'react';

export type ITPButtonProps = {
  charge: ITPButton_charge$key;
};
const ITPButton = ({ ...props }: ITPButtonProps): ReactNode => {
  const { t } = useTranslation();
  const { setRenderITPBanks } = usePaymentContext();

  const charge = useFragment<ITPButton_charge$key>(
    graphql`
      fragment ITPButton_charge on Charge {
        availablePaymentMethods
        customer {
          id
        }
      }
    `,
    props.charge,
  );

  if (!charge.availablePaymentMethods?.includes(PAYMENT_METHOD_TYPE.ITP)) {
    return null;
  }

  if (!charge.customer?.id) {
    return null;
  }

  return (
    <BoxFlex
      sx={{
        flex: 1,
        '@media print': {
          display: 'none',
        },
      }}
    >
      <ActionButton
        color={'tertiary'}
        onClick={() => setRenderITPBanks(true)}
        startIcon={<AccountBalanceIcon />}
        disabled={false}
        sx={(theme) => {
          return {
            display: 'flex !important',
            width: '100% !important',
            backgroundColor: `${theme.palette.tertiary.main} !important`,
            color: 'white !important',
            border: '0 !important',
          };
        }}
        size={'large'}
        data-testid='btn-copy-qrcode-payment-link'
      >
        <Typography component='span' sx={{ textTransform: 'uppercase' }}>
          {t('Pay with bank')}
        </Typography>
      </ActionButton>
    </BoxFlex>
  );
};

export default ITPButton;
